import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { AccountDisinvestmentStrategy } from '../../Models/Domains/Account/AccountDisinvestmentStrategy';
import { ValidationStatus } from '../../Core/Web/Validation/ValidationStatus';

declare var IS_RUNNING_IN_APP_POOL;

export class AccountDisinvestmentStrategyClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(hierarchyId: string): Promise<AccountDisinvestmentStrategy, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Account/AccountDisinvestmentStrategy/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { hierarchyId: hierarchyId }

    return AjaxWrapper.get<AccountDisinvestmentStrategy, any>(url, data);
  }
  public put(accountDisinvestmentStrategy: AccountDisinvestmentStrategy): Promise<ValidationStatus, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Account/AccountDisinvestmentStrategy/Put';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { accountDisinvestmentStrategy: accountDisinvestmentStrategy }

    return AjaxWrapper.put<ValidationStatus, any>(url, data);
  }
}

